var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"home-page"},[(_vm.showUpload)?_c('UploadPage'):(_vm.showProcessing)?_c('ProcessingPage'):(_vm.showSelectCase)?_c('SelectCasePage'):(_vm.showResultsReady)?_c('ResultsReadyPage'):(_vm.showResults)?_c('ResultsPage'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }